export default __webpack_public_path__ + "static/media/no-credit-card.3bb82f64.svg";